import React, { PropsWithChildren } from 'react';
import NotificationSidebar from './SIdebar';
import NotificationHeader from './Header';

export default function NotificationsLayout({ children }: PropsWithChildren) {
  return (
    <main className="guidance w-full min-h-screen bg-[#f7f8fc]" id="guidance">
      <NotificationHeader />
      <div className="grid grid-cols-[230px_1fr] gap-[20px] items-start pr-[20px]">
        <NotificationSidebar />
        {children}
      </div>
    </main>
  );
}
